module.exports = __webpack_public_path__ + "static/img/rank_341.5162188.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_341.png
// module id = fCQ2
// module chunks = 1